import Mark from "./Mark.ts";
import MarkText from "../components/MarkText.ts";
import {Container, Graphics, Sprite, Text, TextStyle} from "pixi.js";
import DecodingModel from "../models/DecodingModel.ts";
import IMark from "../interfaces/IMark.ts";
import RhColors from "@/models/RhColors.ts";

export default class SoundOfLongOMark extends Mark implements IMark
{
    public get targetX():number
    {
        if(this._targetX == undefined)
        {
            if(this.targetTextField)
            {
                this._targetX = 0;
            }
            else
            {
                this._targetX = 0;
            }
        }
        return this._targetX;
    }

    public get targetY():number
    {
        if(this._targetY == undefined)
        {
            if(this.targetTextField)
            {
                this._targetY = this.targetTextField.y;
            }
            else
            {
                this._targetY = 0;
            }
        }
        return this._targetY;
    }

    constructor(targetTextField?:MarkText, color=RhColors.MARK_PRIMARY)
    {
        super(color);
        this.targetTextField = targetTextField;
        this._init();
    }

    private _init():void {
        this.markWidth = 10;
        this.markHeight = 10;
        if(this.targetTextField)
        {
            this.parentTarget = this.targetTextField;
        }
    }

    private createMark(color:string=this.color, visible:boolean=true):Graphics | Sprite | Text | Container
    {
        const markXOffset: number = 0;
        const markYOffset: number = -25;

        let mark = new Container();

        let gr = new Graphics();
        gr.moveTo(markXOffset, markYOffset + this.strokeThickness / 2);
        gr.lineTo(markXOffset + this.markWidth, markYOffset + this.strokeThickness / 2);
        gr.stroke({width:this.strokeThickness, color:this.color, cap:"round"});
        mark.addChild(gr);

        const style = new TextStyle({
            fontFamily: DecodingModel.getInstance().fontFamily,
            fontSize: 40,
            fill: this.color,
            align: 'center'
        });
        const letter = new Text({text:"o", style:style});
        letter.x = (this.markWidth / 2) - (letter.width / 2);
        letter.y = -(letter.height / 1.5);
        mark.addChild(letter);

        mark.visible = visible;
        this.addChild(mark);
        //mark.cacheAsBitmap = true;
        return mark;
    }

    public override create():void
    {
        this.createMarks();
    }

    public createMarks():void
    {
        this.mark = this.createMark();
        this.markHighlight = this.createMark(this.highlightColor, false);
    }

}